import { render, staticRenderFns } from "./ActivarCuenta.vue?vue&type=template&id=0f6b931f&scoped=true"
import script from "./ActivarCuenta.vue?vue&type=script&lang=js"
export * from "./ActivarCuenta.vue?vue&type=script&lang=js"
import style0 from "./ActivarCuenta.vue?vue&type=style&index=0&id=0f6b931f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6b931f",
  null
  
)

export default component.exports